import React from 'react'
import { Row, Col } from 'react-bootstrap'
import { PAGE_URL_CATALOG, PAGE_URL_CART } from 'SiteURLs'

interface ITopNavExpLinkNotAuthProps {
  onClick: VoidFunction
  onLogin: (event: React.MouseEvent<HTMLAnchorElement>) => void
}

const TopNavExpLinkNotAuth: React.FC<ITopNavExpLinkNotAuthProps> = ({
  onClick,
  onLogin,
}) => {
  return (
    <>
      {/* <div className='sm-height-col-disp'> */}
      <Row>
        <Col>
          <a
            href={'#/' + PAGE_URL_CATALOG}
            onClick={onClick}
            className='font-rem-15 nav-link'
          >
            Товары
          </a>
        </Col>
      </Row>

      <Row>
        <Col>
          <a
            href={'#/' + PAGE_URL_CART}
            onClick={onClick}
            className='font-rem-15 nav-link'
          >
            Корзина
          </a>
        </Col>
      </Row>

      <Row>
        <Col>
          <a href='#/' className='font-rem-15 nav-link' onClick={onLogin}>
            Вход
          </a>
        </Col>
      </Row>
      {/* </div> */}
    </>
  )
}
export default TopNavExpLinkNotAuth
